export default __webpack_public_path__ + "static/media/carousel-1-ROI-global-maximize-v4.a96149fb.png";